
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"stroke-primary",attrs:{"cx":"25","cy":"25","r":"21.2","stroke":"#8ED4D2","stroke-width":"7.6"}}),_c('path',{staticClass:"stroke-primary",attrs:{"d":"M15 23.533L21.91 31 34 17","stroke":"#8ED4D2","stroke-width":"7.6"}})])
          )
        }
      }
    